import clsx from 'clsx';
import { Tooltip } from 'primereact/tooltip';
import { ReactNode } from 'react';
import { MenuItem } from '../Menu';

export interface MenuItemTooltipProps {
    id: string;
    tooltip: string;
    item: MenuItem;
    wrapperClassName?: string;
    position?: 'top' | 'bottom' | 'left' | 'right' | 'mouse';
}

export function MenuItemTooltip(params: MenuItemTooltipProps): ReactNode {
    const { id, tooltip, position, wrapperClassName } = params;

    const { label, icon, disabled, command } = params.item;

    const className = clsx(
        'flex gap-2 align-items-center p-menuitem-content',
        wrapperClassName,
    );
    const linkClassName = clsx('p-menuitem-link w-full', {
        'p-disabled': disabled,
    });

    return (
        <>
            <Tooltip target={`#${id}`} />
            <div
                id={id}
                data-pr-tooltip={tooltip}
                data-pr-position={position}
                className={className}
                onClick={(event) => {
                    if (!disabled && command) {
                        command({ originalEvent: event, item: params.item });
                    }
                }}
            >
                <div className={linkClassName}>
                    {icon}

                    {label}
                </div>
            </div>
        </>
    );
}
